import { StyledSocialMediaFixed } from "./styled/SocialMediaFixed.styled";
import { FaWhatsapp, FaPhone } from "react-icons/fa";

const call = () => {
  window.open("tel:08116541800");
};

const wa = () => {
  window.open(
    "https://wa.me/+628116541800?text=[NXP] Halo Sardana Berlian. Saya tertarik dengan produk Mitsubishi New Xpander."
  );
};

const SocialMediaFixed = () => {
  return (
    <StyledSocialMediaFixed>
      <div className="row text-center" style={{ cursor: "pointer" }}>
        <div className="col-6 p-2 bg-primary text-white" onClick={call}>
          <FaPhone />
          <br />
          <small>Telepon sekarang</small>
        </div>
        <div className="col-6 p-2 bg-success text-white" onClick={wa}>
          <FaWhatsapp />
          <br />
          <small>Whatsapp</small>
        </div>
      </div>
    </StyledSocialMediaFixed>
  );
};

export default SocialMediaFixed;
